export default {
	SET_PRIVACY (state, val) {
		state.privacy = val
	},
	SET_TERMS (state, val) {
		state.terms = val
	},
	SET_WARNINGS (state, val) {
		state.warnings = val
	},
	SET_LOADING (state, val) {
		state.loading = val
	},
	SET_LOCALE (state, val) {
		state.locale = val
	},
}
